<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col></mtg-table-identity-col>
    <mtg-table-col-group title="Всего">
      <mtg-table-col>игр</mtg-table-col>
      <mtg-table-col>побед</mtg-table-col>
      <mtg-table-col
        *ngIf="tournament.settings.overtimeType === overtimeTypes.without_overtime"
      >ничьих</mtg-table-col>
      <mtg-table-col>поражений</mtg-table-col>
      <mtg-table-col>очков</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Основное время" *ngIf="tournament.settings.overtimeType !== overtimeTypes.without_overtime">
      <mtg-table-col>побед</mtg-table-col>
      <mtg-table-col>поражений</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Доп. время и 7м"
                         *ngIf="tournament.settings.overtimeType !== overtimeTypes.without_overtime"
    >
      <mtg-table-col>побед</mtg-table-col>
      <mtg-table-col>поражений</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Голы">
      <mtg-table-col>забито</mtg-table-col>
      <mtg-table-col>пропущено</mtg-table-col>
      <mtg-table-col>разница</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>Последние 10 игр</mtg-table-col>
  </mtg-table-header-row>
  <mtg-table-row *ngFor="let tournamentTeam of teams; let i = index;">
    <mtg-table-identity-col>
      <div class="number">{{ i + 1 }}</div>
      <div class="photo">
        <a
          [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
          queryParamsHandling="preserve"
        >
          <img [src]="tournamentTeam.tournamentTeam.logo.path"
               *ngIf="tournamentTeam.tournamentTeam.logo.path"
               [alt]="tournamentTeam.tournamentTeam.name"
          />
          <div [class]="tournamentTeam.tournamentTeam.team.getEmptyLogoClass()" *ngIf="!tournamentTeam.tournamentTeam.logo.path"></div>
        </a>
      </div>
      <div class="info">
        <div class="name">
          <a
            [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
            queryParamsHandling="preserve"
          >{{ tournamentTeam.tournamentTeam.name }}</a>
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ tournamentTeam.gamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.wonGamesCount }}</mtg-table-col>
      <mtg-table-col
        *ngIf="tournament.settings.overtimeType === overtimeTypes.without_overtime"
      >{{ tournamentTeam.drawGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.gamesCount - tournamentTeam.wonGamesCount - tournamentTeam.drawGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.points || 0 }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group *ngIf="tournament.settings.overtimeType !== overtimeTypes.without_overtime">
      <mtg-table-col>{{ tournamentTeam.winNormalTimeGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.loseNormalTimeGamesCount }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group *ngIf="tournament.settings.overtimeType !== overtimeTypes.without_overtime">
      <mtg-table-col>{{ tournamentTeam.winOvertimeGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.loseOvertimeGamesCount }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ tournamentTeam.scoreSum }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.missedSum }}</mtg-table-col>
      <mtg-table-col>
        {{ tournamentTeam.scoreSum > tournamentTeam.missedSum ? '+' : ''}}
        {{ tournamentTeam.scoreSum - tournamentTeam.missedSum }}
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>{{ tournamentTeam.lastGamesWon }} из {{ tournamentTeam.lastGamesCount }}</mtg-table-col>
  </mtg-table-row>
</mtg-table>
